import Link from "next/link";
import React from "react";
import { RiPagesLine } from "react-icons/ri";
const DomainStatsCard = ({ totalDomains, tlds, slds,reservedCount }) => (
  <div className="">
    {/* Background Icon */}
   

    {/* <div className="flex items-center justify-between mb-2">
      <div className="flex items-center gap-2">
        <RiPagesLine className="text-accent text-xl" />
        <h3 className="text-base font-display">Domain Statistics</h3>
      </div>
    </div> */}

    <div className="mt-3 space-y-3 relative z-10">
      <div className="bg-jacarta-50 dark:bg-jacarta-700/50 rounded-xl p-4 backdrop-blur-sm">
        <p className="text-2xl font-bold text-jacarta-700 dark:text-white">
          {totalDomains?.toLocaleString()}
        </p>
        <p className="text-sm text-jacarta-700 dark:text-jacarta-300">
          Total Domains
        </p>
      </div>

      <div className="grid grid-cols-2 gap-3">
        <Link
          href="/dashboard/my-domains"
          className="bg-jacarta-50 dark:bg-jacarta-700/50 p-3 rounded-xl backdrop-blur-sm group hover:bg-accent/20 transition-all"
        >
          <div className="flex items-center gap-2 mb-1">
            <span className="text-xs px-2 py-1 bg-accent/10 dark:text-accent rounded-lg">
              TLD
            </span>
            <p className="text-lg font-semibold dark:text-accent">
              {tlds?.toLocaleString()}
            </p>
          </div>
          <div className="flex items-center justify-between">
            <p className="text-xs text-jacarta-700 dark:text-jacarta-300">
              Top Level Domains
            </p>
            <span className="text-xs text-accent opacity-0 group-hover:opacity-100 transition-all">
              View →
            </span>
          </div>
        </Link>
        <Link
          href="/dashboard/my-domains"
          className="bg-jacarta-50 dark:bg-jacarta-700/50 p-3 rounded-xl backdrop-blur-sm group hover:bg-accent/20 transition-all"
        >
          <div className="flex items-center gap-2 mb-1">
            <span className="text-xs px-2 py-1 bg-accent/10 dark:text-accent rounded-lg">
              SLD
            </span>
            <p className="text-lg font-semibold dark:text-accent">
              {slds?.toLocaleString()}
            </p>
          </div>
          <div className="flex items-center justify-between">
            <p className="text-xs text-jacarta-700 dark:text-jacarta-300">
              Second Level Domains
            </p>
            <span className="text-xs text-accent opacity-0 group-hover:opacity-100 transition-all">
              View →
            </span>
          </div>
        </Link>
        <Link
          href="/dashboard/my-domains"
          className="bg-jacarta-50 dark:bg-jacarta-700/50 p-3 rounded-xl backdrop-blur-sm group hover:bg-accent/20 transition-all"
        >
          <div className="flex items-center gap-2 mb-1">
            <span className="text-xs px-2 py-1 bg-accent/10 dark:text-accent rounded-lg">
              Reserved
            </span>
            <p className="text-lg font-semibold dark:text-accent">
              {reservedCount?.toLocaleString()}
            </p>
          </div>
          <div className="flex items-center justify-between">
            <p className="text-xs text-jacarta-700 dark:text-jacarta-300">
             Reserved Domains
            </p>
            <span className="text-xs text-accent opacity-0 group-hover:opacity-100 transition-all">
              View →
            </span>
          </div>
        </Link>
      </div>
    </div>
  </div>
);

export default DomainStatsCard;
